module.exports = __webpack_public_path__ + "static/media/Carrarese.c1760f3c.png";